import { ChangeDetectorRef, Component } from '@angular/core';
import { Platform, ToastController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AuthenticationService } from './services/authguard/authentication.service';
import { Router } from '@angular/router';
import { UpdateService } from "./services/update/update.service";
import { FCM } from 'cordova-plugin-fcm-with-dependecy-updated/ionic';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './services/language/language.service';
import { Storage } from '@ionic/storage';
import { ThemeService } from './services/ThemeService/theme-service.service';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx'
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { AnalyticsProvider } from 'providers/analytics/analytics';
import { RtlServiceService } from './services/rtl/rtl-service.service';
import { MediaMatcher } from '@angular/cdk/layout';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {

  source_from: any;
  language_key: any;
  mobileQuery: MediaQueryList; // ✅ Removed readonly, will be assigned in constructor
  isSmallScreen: boolean;
  
  
  constructor(
    // private readonly mobileQuery: MediaQueryList,
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private authenticationService: AuthenticationService,
    private router: Router,
    private updateService: UpdateService,
    private transLateService: TranslateService,
    private languageService: LanguageService,
    private toastController: ToastController,
    private storage: Storage,
    private themeService: ThemeService,
    private screenOrientation: ScreenOrientation,
    private androidPermissions: AndroidPermissions,
    private analytic: AnalyticsProvider,
    private media: MediaMatcher, 
    private changeDetectorRef: ChangeDetectorRef,
    private rtlservice: RtlServiceService

  ) {

    this.initializeApp();
    // this.rtlservice.setRTL();
    this.languageService.setInitialAppLanguage();
    this.themeSelector()
    // this.storage.clear().then(res => { console.log(res) })
      this.initializeLanguageAndDirection();

      this.mobileQuery = this.media.matchMedia('(max-width: 720px)');
    this.isSmallScreen = this.mobileQuery.matches;
 
    this.mobileQuery.addEventListener('change', () => {
      this.changeDetectorRef.detectChanges();
      this.isSmallScreen = this.mobileQuery.matches;
    });
  }


  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleLightContent()
      this.splashScreen.hide();

      if (this.platform.is('android')) {
        this.source_from = 2;
      }
      else if (this.platform.is('ios')) {
        this.source_from = 3;
      }
      else {
        this.source_from = 4;
      }
      if (this.platform.is("android") || this.platform.is("ios")) {
        this.updateService.descideUpdateAction();
      }
      this.authenticationService.authenticationState.subscribe(state => {
        let url = window.localStorage.getItem('pageUrl');
        // console.log(state,"state")
        if (state) {

          this.router.navigate(['/tabs-page/dashboard']);
          
        } else {
          this.router.navigate(['/onboarding/startnow']);
          // this.router.navigate(['/onboarding/sendreferalrequesr']);

        }
      });
      // let status bar overlay webview
      // this.statusBar.overlaysWebView(true);
      // set status bar to white
      this.statusBar.styleDefault();
      this.statusBar.overlaysWebView(false);
      this.statusBar.backgroundColorByHexString('#000000');
      this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.ACCESS_FINE_LOCATION)
        .then(
          result => console.log('Has permission?', result.hasPermission),
          err => this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.ACCESS_FINE_LOCATION)
        )
      this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.CAMERA)
        .then(
          result => console.log('Has permission?', result.hasPermission),
          err => this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.CAMERA)
        )
      if (localStorage.getItem('langTxt') == null || localStorage.getItem('langTxt') == undefined) {
        let langTxt = 'en'
        localStorage.setItem('langTxt', 'en');
        this.transLateService.setDefaultLang(langTxt);
        console.log(localStorage.getItem('langTxt'))
      }
      else {
        let langTxt = localStorage.getItem('langTxt');
        this.transLateService.setDefaultLang(langTxt);
        console.log(localStorage.getItem('langTxt'))
      }
      if (localStorage.getItem('SELECTED_LANGUAGE') == null || localStorage.getItem('SELECTED_LANGUAGE') == undefined) {
        let langTxt = 'en'
        localStorage.setItem('SELECTED_LANGUAGE', 'en');
        // this.transLateService.setDefaultLang(langTxt);
        console.log(localStorage.getItem('SELECTED_LANGUAGE'))
      }

      if (this.platform.is('cordova')) {
        FCM.requestPushPermission().then((res) => {

          console.log("Permission accepted")

        }, (err) => {

          console.log("Permission rejected")

        })

        FCM.getToken().then(token => {
          // debugger
          localStorage.setItem('fcm', token)
        }).catch(err => console.log('err:::', err));

        FCM.onNotification().subscribe(data => {
          if (data.wasTapped) {
            console.log("Received in background");
          } else {
            console.log("Received in foreground");
          };
        });

        FCM.onTokenRefresh().subscribe(token => {
          // backend.registerToken(token);

          console.log('refresh token', token)
          localStorage.setItem('fcm', token)
        });

        FCM.hasPermission().then(hasPermission => {
          if (hasPermission) {
            console.log("Has permission!");
          } else {
            console.log('No permission')
            FCM.requestPushPermission().then((res) => {

              console.log("Permission accepted")

            }, (err) => {

              console.log("Permission rejected")

            })
          }
        })

        FCM.clearAllNotifications();
      }

    });
    this.platform.resume.subscribe(async () => {
      if (this.platform.is("android") || this.platform.is("ios")) {
        this.updateService.descideUpdateAction();
      }
    });
  }

  async checkAndRedirect() {
    let state = await this.authenticationService.isAuthenticated();
    //console.log(state);

  }


  pushLocalNotification(data) {
    console.log('notification data::', data)
    this.presentToastWithOptions(data)
  }

  async presentToastWithOptions(data) {
    const toast = await this.toastController.create({
      header: 'V-Scan',
      message: data.body,
      position: 'top',
      cssClass: 'notification-alert',
      duration: 5000,
      buttons: [
        {
          side: 'end',
          // icon: 'star',
          cssClass: 'notification-button',
          text: 'VIEW',
          handler: () => {
            this.router.navigateByUrl('/tabs-page/dashboard/notification')
          }
        }
      ]
    });
    toast.present();
  }


  callTranslationEvent() {
    this.transLateService.setDefaultLang('en');
    this.languageService.$changeLanguage.subscribe((lang) => {
      this.language_key = lang;
      //console.log("change Language = ", this.language_key);
      if (this.language_key['type'] == 'language' && this.language_key['data'] == 'en') {
        this.transLateService.use(this.language_key['data']);
      } else if (this.language_key['type'] == 'language' && this.language_key['data'] == 'tm') {
        this.transLateService.use(this.language_key['data'])
      }

    })
  }

  themeSelector() {
    // console.log(localStorage.getItem('Theme'))s
    const ThemeItem = JSON.parse(localStorage.getItem('Theme') || null)
    if (ThemeItem) {
      let ThemeId = ThemeItem
      let theme = this.themeService.ThemesList.filter(ele => ele.id == ThemeId)[0].value
      this.themeService.setTheme(theme)
    } else {
      this.themeService.setTheme('')
    }
  }

  ngOnDestroy() {
    this.storage.clear().then(res => { console.log(res) })
  }



   initializeLanguageAndDirection() {
    const savedLang = localStorage.getItem('SELECTED_LANGUAGE') || 'en';

    // Set translation language
    this.transLateService.setDefaultLang(savedLang);
    this.transLateService.use(savedLang);

    // Set text direction
    if (savedLang === 'ar' || savedLang === 'ur') {
      this.rtlservice.setRTL();
    } else {
      this.rtlservice.setLTR();
    }
  }
}